import { Empty, Pagination, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import './index.less';
import { getFAQList, getFAQTypeList } from '@/api/questions';
import QuestionCard from "@/components/QuestionCard";

const FAQ: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [list, setList] = useState<any[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [current, setCurrent] = useState<number>(1);
  const [tabs, setTabs] = useState<any[]>([]);
  const [currentTab, setCurrentTab] = useState<string>('');
  useEffect(() => {
    getFAQTypeList().then((res: any) => {
      if (res.code === 200) {
        setTabs(res.result);
        setCurrentTab(res.result[0].code);
      }
    });
  }, []);
  const getList = (current:number) => {
    setLoading(true);
    getFAQList({
      pageNumber: current, // 当前页数
      pageSize: 5, // 页面大小
      faqType: currentTab
    }).then((res: any) => {
      if (res.code === 200) {
        setList(res.result.records);
        setTotal(res.result.total);
        setCurrent(res.result.current);
      }
    }).catch((err) => {
      console.error(err);
    }).finally(()=>{
      setTimeout(() => {
        setLoading(false);
      }, 300);
    })
    ;
  };
  const paginationChange = (e: number) => {
    console.log(e)
    getList(e);
  }
  useEffect(() => {
    if(currentTab){
      getList(1);
    }
  }, [currentTab]);

  return <div className="faq-page">
    <h1 className='faq-page-title'>常见Q&A</h1>
    <div className='faq-page-tab'>
      {tabs.map((item) => (
        <span key={item.code} className={currentTab === item.code ? 'faq-page-tab-active' : ''} onClick={() => setCurrentTab(item.code)}>{item.description}</span>
      ))}
    </div>
    <Spin spinning={loading}>
      {
        list.length === 0 ? 
        <Empty image={<img src={require("@/assets/images/message/empty.png")}></img>} style={{marginTop: '100px'}}/> : 
        <div className="faq-page-content">
          {list.map((item: any) => {
            return (
              <QuestionCard
                item={item}
                key={item.id}
                type="faq"
              />
            );
          })}
        </div>
      }
      <div>
        <Pagination
          pageSize={5}
          current={current}
          showSizeChanger={false}
          total={total}
          rootClassName="pagination"
          onChange={paginationChange}
        />
      </div>
    </Spin>
  </div>;
};

export default FAQ;